module.exports = __webpack_public_path__ + "media/components/assets/images/tamgeulAllkill/image1-0390289d324dde390a8c479cb9f1f329.png";